import { authService } from '@aglenergy/agl.sales.authentication';
import { store } from 'app/shared/store/store';
import { BundleSearchResponse } from 'app/shared/models/bundle-search-response.model';
import { ProductSearchRequestModel } from 'app/shared/models/productSearchRequestModel';
import { ResponseError } from 'app/shared/models/response-error.error';
import { StoreKeys } from 'app/shared/constants/store-keys.enum';
import { flowService } from 'app/shared/services/flow/flow-service';
import { getHeaders } from 'app/shared/utilities/helper-functions';

class BundleApiService {
  private bundleSearchPath = '/products/bundle/search';
  private authenticatedBundleSearchPath = '/products/bundle/customerSearch';

  public getBundleProducts = async (searchModel: ProductSearchRequestModel): Promise<BundleSearchResponse> => {
    const configData = store.get('configData');
    const init = {
      method: 'POST',
      body: JSON.stringify({
        ...searchModel
      }),
      headers: getHeaders()
    };
    return await fetch(`${configData.bffApiUrl}${this.bundleSearchPath}`, init)
      .then((response) => {
        if (!response.ok) {
          if (response.status === 300) {
            throw new ResponseError(response.statusText, 'multipleMatching');
          } else if (response.status === 500) {
            throw new ResponseError(response.statusText, 'systemError');
          } else {
            throw new ResponseError(`Unable to retrieve energy products`, 'serviceNotAvailable');
          }
        }
        flowService.setFlowError(null);
        store.set(StoreKeys.responseError, null);
        return response.json();
      })
      .catch((error) => {
        if (error.errorType) {
          flowService.setFlowError(error);
          throw new ResponseError(error.message, error.errorType);
        } else {
          throw new ResponseError(error);
        }
      });
  };

  public getAuthenticatedBundleProducts = async (): Promise<BundleSearchResponse> => {
    const configData = store.get('configData');
    const token = await authService.getAuth0Client().getTokenSilently({ audience: configData.auth0.audience });

    const init = {
      method: 'POST',
      headers: getHeaders(false, `Bearer ${token}`)
    };
    return await fetch(`${configData.bffApiUrl}${this.authenticatedBundleSearchPath}`, init)
      .then((response) => {
        switch (response.status) {
          case 200:
            flowService.setFlowError(null);
            store.set(StoreKeys.responseError, null);
            return response.json();
          case 300:
            store.set('addressRequired', true);
            throw new ResponseError(response.statusText, 'multipleMatching');
          case 400:
            store.set('addressRequired', true);
            throw new ResponseError(response.statusText, 'systemError');
          case 500:
            throw new ResponseError(response.statusText, 'systemError');
          default:
            throw new ResponseError(`Unable to retrieve energy products`, 'serviceNotAvailable');
        }
      })
      .catch((error) => {
        if (error.errorType) {
          flowService.setFlowError(error);
          throw new ResponseError(error.message, error.errorType);
        } else {
          throw new ResponseError(error);
        }
      });
  };
}
export const bundleApiService = new BundleApiService();
